import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import { costCodeKeys } from "@/lib/query";

export interface CostCode {
  id: string;
  orgId: string;
  code: string;
  description: string;
  csiDivision: string | null;
  csiSubdivision: string | null;
  category: string | null;
  parentCodeId: string | null;
  erpCode: string | null;
  itemNo: string | null;
  ownerPayApp: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export function useCostCodes() {
  return useQuery({
    queryKey: costCodeKeys.all,
    queryFn: () => apiFetch<CostCode[]>("/cost-codes"),
  });
}
